import { Menu } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/shallow';

import { MenuActionItem } from 'app/modules/wallforming/components/menu-container/MenuActionItem';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

export const ViewMenu = () => {
    const { t } = useTranslation();

    const { mainCameraControlsRef, mainWebGLRenderer } = usePlacementStore(
        useShallow((state) => ({
            mainCameraControlsRef: state.mainCameraControlsRef,
            mainWebGLRenderer: state.mainWebGLRendererRef.current
        }))
    );

    return (
        <Menu offset={0} position="bottom-start" shadow="md" trigger="click-hover">
            <Menu.Target>
                <button
                    className="px-4 py-0.5 text-sm font-medium text-text-default hover:bg-background-gray-strong! rounded transition-colors h-full focus-visible:outline-none"
                    style={{ background: 'none', border: 'none', cursor: 'pointer' }}
                >
                    {t('labelViewMenu')}
                </button>
            </Menu.Target>
            <Menu.Dropdown>
                <MenuActionItem.FocusBuilding
                    cameraControlsRef={mainCameraControlsRef}
                    domElement={mainWebGLRenderer?.domElement ?? null}
                />
                <Menu.Divider />
                <MenuActionItem.LockView setLocked={true} />
                <MenuActionItem.LockView setLocked={false} />
                <Menu.Divider />
                <span className="text-xs text-text-ultra-light mt-2 ml-1">
                    <span className="font-mono">MMB = </span> Middle Mouse Button
                </span>
            </Menu.Dropdown>
        </Menu>
    );
};
